import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <Layout>
    <SEO title="Page Not Found | Sandend House" noIndex />
    <section className="py-32 lg:py-40 text-center">
      <div className="section-container">
        <h1 className="font-serif text-4xl lg:text-5xl mb-4" data-testid="404-heading">This page could not be found.</h1>
        <p className="text-[var(--sh-grey)] mb-8">The page you are looking for may have been moved or no longer exists.</p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/" className="btn-primary" data-testid="404-home">Return Home</Link>
          <Link to="/contact" className="btn-secondary" data-testid="404-contact">Contact Sandend House</Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default NotFoundPage;
